import { DateTime } from "luxon";
import { Timestamp } from "models/artistSignup";


export const getDateTimeString = (dateTime: Timestamp) => dateTime
  ? DateTime.fromJSDate(dateTime.toDate()).toFormat("MM-dd-yyyy hh:mm:ss a")
  : "-";
